/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Shipping_N_Delivery__DescriptionInputs */

const en_help_center__shipping_n_delivery__description = /** @type {(inputs: Help_Center__Shipping_N_Delivery__DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery areas, shipping costs, and product warranties`)
};

/**
* | output |
* | --- |
* | "Delivery areas, shipping costs, and product warranties" |
*
* @param {Help_Center__Shipping_N_Delivery__DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__shipping_n_delivery__description = /** @type {((inputs?: Help_Center__Shipping_N_Delivery__DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Shipping_N_Delivery__DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__shipping_n_delivery__description(inputs)
});